module.exports = __webpack_public_path__ + "static/media/1022111.0f47984c.jpg";